var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPersonasicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 92 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#DADFE4",
    cx: 46,
    cy: 46,
    r: 46
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F7F8F9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 50C38.525 50 32 43.475 32 35.5S38.525 21 46.5 21 61 27.525 61 35.5 54.475 50 46.5 50zm0-24.167c-5.317 0-9.667 4.35-9.667 9.667s4.35 9.667 9.667 9.667 9.667-4.35 9.667-9.667-4.35-9.667-9.667-9.667z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6 69c-1.44 0-2.4-.96-2.4-2.4 0-9.36-7.44-16.8-16.8-16.8h-4.8c-9.36 0-16.8 7.44-16.8 16.8 0 1.44-.96 2.4-2.4 2.4s-2.4-.96-2.4-2.4c0-12 9.6-21.6 21.6-21.6h4.8c12 0 21.6 9.6 21.6 21.6 0 1.44-.96 2.4-2.4 2.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonasicon);
export default __webpack_public_path__ + "static/media/Personas icon.e2a4e216.svg";
export { ForwardRef as ReactComponent };